export default "__VITE_ASSET__5Wp5y3wF__"